import {Spot} from "../types";
import SoundSlotSection, {LanguageOption} from "./SoundSlotSection";
import {Stack} from "@chakra-ui/react";
import {useContext, useMemo} from "react";
import {AppContext, AppContextI} from "../context/ContextWrapper";

type Props = {
	spot: Spot
}

const SoundFilesSection = ({spot}: Props) => {
	const appContext: AppContextI = useContext<AppContextI>(AppContext);
	const area = appContext.getArea();
	const languages: LanguageOption[] = useMemo(() => {
		const areaLanguages = area?.languages;
		const available = areaLanguages?.available || [];
		const fallbackDefault = areaLanguages?.default ? areaLanguages.default.toUpperCase() : "";
		const fallbackLabels: Record<string, string> = {
			DA: "Danish",
			EN: "English"
		};
		const baseList = available.length > 0
			? available
			: [
				{code: "EN", label: fallbackLabels.EN},
				{code: "DA", label: fallbackLabels.DA}
			];
		const mapped = baseList.map((language) => {
			const languageCode = (language.code || "").toUpperCase();
			return {
				code: languageCode,
				label: language.label,
				isDefault: fallbackDefault ? languageCode === fallbackDefault : false
			};
		});
		return mapped.sort((a, b) => {
			if (a.isDefault && !b.isDefault) {
				return -1;
			}
			if (!a.isDefault && b.isDefault) {
				return 1;
			}
			return a.code.localeCompare(b.code);
		});
	}, [area]);

	return <Stack>
		<SoundSlotSection spot={spot} title={"Main sound"} isAmbient={false} languages={languages}/>
		<SoundSlotSection spot={spot} title={"Ambient sound"} isAmbient={true} languages={languages}/>
	</Stack>
}

export default SoundFilesSection;
